const accept = {
  icon: ".svg, .png",
  img: ".jpg, .png, .jpeg",
  video: ".mp4, .webm",
  subtitle: ".srt, .vtt",
  every : ".svg, .png, .jpg, .png, .jpeg, .mp4, .webm, .srt, .vtt, .xlsx , .zip"
};
export default accept;
